import type { TextareaHTMLAttributes } from "react";
import { cn } from "../lib/cn";

export function TextArea({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea className={cn("cf-input", className)} {...props} />;
}
